module.exports = __webpack_public_path__ + "assets/img/组 9@2x.5a6dd46a.png";